'use client';
import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Icons } from '../../../assets/imgs/icons';
/** Imported for form validation */
import { useFormik } from 'formik';
import { loginSchema } from '../../Patient/Extras/AuthenticationFormik';
import showToast from '../../../Shared/Utils/ToastNotification';
// import Service from './Service';
import { useDispatch, useSelector } from 'react-redux';
import {
  setPendingEmail,
  userlogin,
  // setPendingEmail
} from '../../../Shared/Slice/AuthSlice';
import Slider from '../../Patient/Components/Slider';
import Service from '../../Patient/Auth/Signup/services/Service';

const Login = () => {
  const [showPass, setShowPass] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.loader.login);
  const loginInitialValues = {
    email: '',
    password: '',
    role: 'admin',
  };
  const formik = useFormik({
    initialValues: loginInitialValues,
    validationSchema: loginSchema,
    validateOnBlur: true,
    validateOnChange: true,
    onSubmit: async (values) => {
      try {
        // =================== Future real backend login / OTP logic ===================
        const trimmedPayload = {
          ...values,
          email: values.email?.trim(),
          password: values.password?.trim(),
        };

        const res = await Service.login(trimmedPayload);
        console.log(res, '/accounts/admins');
        const resData = res?.data;
        const role = resData?.role;

        if (!resData) {
          showToast('error', 'Invalid server response');
          return;
        }
        console.log(resData, '/accounts/admins');
        if (resData.otp_required) {
          showToast('info', 'OTP sent to your email. Please verify.');
          dispatch(setPendingEmail({ email: trimmedPayload.email, justRegistered: false }));
          navigate('/otp-verification', { state: { login: true } });
        } else if (resData.access) {
          if (resData.refresh) {
            sessionStorage.setItem('refresh_token', resData.refresh);
          }
          dispatch(
            userlogin({
              token: resData.access, // real JWT from backend
              user: resData.user || { email: trimmedPayload.email },
              justRegistered: false,
              role: role,
            })
          );

          showToast('success', 'Logged in successfully');
          navigate('/dashboard');
        } else {
          showToast('error', 'Login failed: unexpected response');
        }
      } catch (error) {
        const msg = error.response?.data?.message || 'Login failed. Please check credentials.';
        showToast('error', msg);
      }
    },
  });

  const error = (name) => (formik.touched[name] && formik.errors[name] ? <div className="error">{formik.errors[name]}</div> : null);

  return (
    <>
      <div className="login">
        <div className="login-form loginpage">
          <div className="login-head"></div>
          <div className="login-head-cont">
            <h2>Welcome Back !👋</h2>
            <p>Kindly fill in your details below to login an account</p>
          </div>

          <form onSubmit={formik.handleSubmit} noValidate>
            <div className="form-group">
              <label>
                Email <span className="require">*</span>
              </label>
              <input
                className={`form-control${error('email') ? ' is-invalid' : ''}`}
                type="email"
                name="email"
                placeholder="Enter email"
                value={formik.values.email}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              {error('email')}
            </div>

            <div className="form-group pass">
              <label>
                Password <span className="require">*</span>
              </label>
              <div className="password-input-wrap">
                <input
                  className={`form-control${error('password') ? ' is-invalid' : ''}`}
                  type={showPass ? 'text' : 'password'}
                  placeholder="**************"
                  name="password"
                  value={formik.values.password}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                <button type="button" className="eye-toggle" onClick={() => setShowPass(!showPass)}>
                  {showPass ? <Icons.EyeOpen className="eye open" /> : <Icons.EyeClose className="eye close" />}
                </button>
              </div>
              {error('password')}
            </div>

            <div className="form_col forget-passfield">
              <Link to="/forgot-password" className="forgot-pass">
                Forgot Password?
              </Link>
            </div>

            <button className="btn" type="submit" disabled={formik.isSubmitting || !formik.isValid || isLoading}>
              {isLoading ? 'Logging in...' : 'Login'}
            </button>
          </form>
        </div>

        <div className="login-content">
          <Slider type="signin" />
        </div>
      </div>
    </>
  );
};

export default Login;
